/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type QueryOrderingDirection = (typeof QueryOrderingDirection)[keyof typeof QueryOrderingDirection];

export const QueryOrderingDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;
